<template>
  <div class="details" v-if="product">
    <breadcrumb v-if='$i18n.locale=="en"' v-bind:path2.name="product.Name"></breadcrumb>
    <breadcrumb v-if='$i18n.locale=="ch"' v-bind:path2.name="product.Description"></breadcrumb>
    <div class="page-width display">
      <!--product image-->
      <div class="productsingleli">
        <div class="ps_right">
          <div class="thumbnails-wrapper">
            <ul>
              <li v-for="(item,index) in product.Images" :class="isactive == index?'isactive':''" :key="index">
                <a href="javascript:void(0)" @click="tabImg(index)"><img :src="item" alt=""></a>
                <!-- <a href="javascript:void(0)" @click="tabImg(0)"><img src="../assets/img/coming.png" alt=""></a> -->
              </li>
            </ul>
          </div>
        </div>
        <div class="ps_left">
          <div class="product-single__photo-wrapper sp-wrap" @click="clickZoom(product.Images)">
            <!-- with zoom in -->
            <div v-show="zoom.screenWidth>773 && product.Images.length !== 0">
              <vue-h-zoom
                :image="bigImg || product.Images[0]"
                :image-full="zoomImg || product.Large_Images[0]"
                :zoom-level="2"
                :width="zoom.width"
                :height="zoom.height"
                :zoom-window-size="1"
                :zoom-window-x="zoom.zoomX"
                :zoom-window-y="zoom.zoomY"
                background-options="true"
              >
              </vue-h-zoom>
            </div>
            <img v-if="product.Images.length === 0" src="../assets/img/coming.png" alt="" class="comingImg"/>
            <!-- no zoom in -->
            <div v-show="zoom.screenWidth<772">
              <img class="mobile-image" :src="bigImg || product.Images[0]" alt="">
            </div>
          </div>
        </div>
      </div>
      <!--end product image-->
      <!--product detail-->
      <div class="product-single__meta">
        <h1 class="product-single__title" v-if='$i18n.locale=="en" && !this.business'>{{product.Name}}</h1>
        <h1 class="product-single__title" v-if='$i18n.locale=="ch" && !this.business'>{{product.Description}}</h1>
        <!-- <h1 class="product-single__title" v-if='$i18n.locale=="en" && this.business'>{{this.b2bName}}</h1>
        <h1 class="product-single__title" v-if='$i18n.locale=="ch" && this.business'>{{this.b2bDescription}}</h1> -->
        <h1 class="product-single__title" v-if='$i18n.locale=="en" && this.business'>{{product.Name}}</h1>
        <h1 class="product-single__title" v-if='$i18n.locale=="ch" && this.business'>{{product.Description}}</h1>
        <div class="product_reviews_below_title">
          <!--review star-->
          <!-- <span class="shopify-product-reviews-badge" data-id="2236667330658"></span>
          <a href="">
            <div class="price__regular">{{review}} review</div>
          </a>
          <a href="">
            <div class="price__regular">Write a review</div>
          </a> -->
          <!--end review star-->
          <!-- <div class="product__price">${{product.Price.toFixed(2)}}</div> -->
         <span class="alcohol" v-if="product.IsAlcohol">Alcohol: must be over 21 years old, CA ONLY</span>
          <!-- v-if B2C -->
          <div v-if="!business" class="price-marge" >
            <!-- <div :class="['product__price', product.IsPromotion ? 'hot' : '']"><span>${{product.Price.toFixed(2)}}</span></div>
            <div class="price_original_detail_page" v-show="product.IsPromotion"><span>${{product.OriginalPrice}}</span></div> -->  
            <div class="product__price"><span class="regular_price" v-if="loggedIn">{{ $t('regular_price') }}</span><span class='regular_price_delete' v-if="loggedIn">${{product.OriginalPrice ? product.OriginalPrice.toFixed(2) : ''}}</span></div>
            <div class="product__price"><span class="on_sale_price" v-if="loggedIn">{{ $t('on_sale') }}</span><span class='on_sale_price' v-if="loggedIn">${{product.Price ? product.Price.toFixed(2) : ''}}</span></div>
            <p v-if="product.DiscountDescription" v-for="(description, index) in product.DiscountDescription" :key="index">{{description}}</p>
          </div>
          <!-- v-else-if B2B! -->
          <div v-if="business" class="price-marge">
            <!-- <div :class="['product__price', product.IsPromotion ? 'hot' : '']"><span>${{product.Price.toFixed(2)}}</span></div>
            <div class="price_original_detail_page" v-show="product.IsPromotion"><span>${{product.OriginalPrice}}</span></div> -->
            <div class="product__price"><span v-if="loggedIn">${{product.Price.toFixed(2)}}</span></div>
            <p v-if="product.DiscountDescription" v-for="(description, index) in product.DiscountDescription" :key="index">{{description}}</p>
            <!-- If there is an Inner, Master and Regular case version of a product.  -->
            <div v-if="productsArray.length === 3" class="b2b-prices">
              <!-- <div :class="['b2b-price', product.IsPromotion ? 'hot' : '']"><span>Single Item: <span class="b2b-cost">${{this.productDetails[0].Price}}</span></span></div> -->
              <div v-if="productsArray.length > 1 && single" :class="['b2b-price', product.IsPromotion ? 'hot' : '']">
                <span v-if="loggedIn">Inner Case ({{this.productDetails[1].ConvertNum}} units): <span class="b2b-cost">${{this.productDetails[1].Price}}</span></span>
                <div class="price_original_detail_page" v-show="this.productDetails[1].IsPromotion"><span v-if="loggedIn">${{this.productDetails[1].OriginalPrice}}</span></div>
              </div>
              <div v-if="productsArray.length > 2 && single" :class="['b2b-price', product.IsPromotion ? 'hot' : '']">
                <span v-if="loggedIn">Master Case ({{this.productDetails[2].ConvertNum}} units): <span class="b2b-cost">${{this.productDetails[2].Price}}</span></span>
                <div class="price_original_detail_page" v-show="this.productDetails[2].IsPromotion"><span v-if="loggedIn">${{this.productDetails[2].OriginalPrice}}</span></div>
              </div>
            </div>
            <!-- if there is an Inner/Master and regular case version of a product.  -->
            <div v-else-if="productsArray.length === 2" class="b2b-prices">
              <div :class="['b2b-price', product.IsPromotion ? 'hot' : '']">
                <span v-if="loggedIn">{{this.innerMaster}} Case ({{this.productDetails[1].ConvertNum}} units):
                  <span class="b2b-cost">${{this.productDetails[1].Price}}</span>
                  <span class="price_original_detail_page" v-show="this.productDetails[1].IsPromotion">
                    <span class="sales-price">${{this.productDetails[1].OriginalPrice}}</span>
                  </span>
                </span>
              </div>
              <div v-if="productsArray.length > 1" :class="['b2b-price', product.IsPromotion ? 'hot' : '']">
                <span v-if="loggedIn">Master Case ({{this.productDetails[2].ConvertNum}} units):
                  <span class="b2b-cost">${{this.productDetails[2].Price}}</span>
                  <span class="price_original_detail_page" v-show="this.productDetails[2].IsPromotion">
                    <span class="sales-price">${{this.productDetails[2].OriginalPrice}}</span>
                  </span>
                </span>
              </div>
            </div>
            <div v-else-if="productsArray.length === 1" class="b2b-prices">
              <div :class="['b2b-price', product.IsPromotion ? 'hot' : '']">
                <span v-if="loggedIn">{{this.innerMaster}} Case ({{this.productDetails[1].ConvertNum}} units):
                  <span class="b2b-cost">${{this.productDetails[1].Price}}</span>
                    <span class="price_original_detail_page" v-show="this.productDetails[1].IsPromotion">
                      <span class="sales-price">${{this.productDetails[1].OriginalPrice}}</span>
                    </span>
                </span>
              </div>
            </div>
          </div>
          <!-- <div class="delivery_txt">
            <span v-show="product.StockLevel<product.MinStockRange&&product.StockLevel>0">{{product.StockLevel}} {{ $t('leftInStock') }}</span>
          </div> -->

          <!-- middle part -->
          <div class="middle-container">
            <div>
              <div class="ref-no">
                <span>{{ $t('referenceNumber') }}:</span>
                <span>{{product.RefNum}}</span>
              </div>
              <div class="barcode">
                <span>UPC:</span>
                <span>{{product.Barcode}}</span>
              </div>
              <!-- <div class="location">
                <span>{{ $t('location') }}:</span> -->
                <!-- <span>{{product.location}}</span> -->
                <!-- <span>{{product.Zone+product.Bin+product.Level}}</span>
              </div> -->
              <div class="shipping_link">
                <a href="/returns-and-refunds">{{ $t('shippingInformation') }}</a>
              </div>
            </div>
            <div v-if="product.IsAFGChioce===true && business" class="afg-tag">
              <img src="../assets/img/afg_choice_single.png" alt="">
              <div class="hoverImg">
                <img src="../assets/img/afgchoice_tag.png" alt="">
              </div>
            </div>
          </div>
          <!-- middle part end -->

          <div class="add_to_cart">
            <div class="qty_and_cart">
              <!-- QTY b2b -->
              <!-- <div v-if="business" class="warehouse-options">
                <span>Warehouse Options</span>
                <el-select class="price-select" v-model="productChoice" placeholder="Select" :style="'width: 250px'"> -->
                  <!-- <div v-if="this.productDetails.length > 1"> -->
                  <!-- <el-option
                    v-for="(item, index) in productsArray"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option> -->
                  <!-- </div> -->
                <!-- </el-select>
              </div> -->
              <!-- end QTY b2b -->
              <div class="mobileqty">
                <div class="qty_input">
                  <el-input-number v-model="num" size="small" :min="1" :max="product.StockLevel" label=""></el-input-number>
                </div>
              </div>
              <!-- add to cart btn -->
              <div v-if="!this.business">
                <!-- b2c -->
                <!-- <div v-if="product.StockLevel>0" class="product-form__item product-form__item--submit product-form__item--no-variants"> -->
                <div v-if="product.IsOverSaleable || product.StockLevel>0" class="product-form__item product-form__item--submit product-form__item--no-variants">
                  <input v-on:click="addToCart(product)" type="button" class="btn product-form__cart-submit fakeBUt" value="Add to Cart">
                  <button style="display:none;" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">
                    <span id="AddToCartText-product-template">{{ $t('addToCart') }}</span>
                  </button>
                </div>
                <!-- end b2c-->
                <!-- b2b -->
                <div v-else class="product-form__item product-form__item--submit product-form__item--no-variants">
                  <input type="button" class="btn product-form__cart-submit fakeBUt" value="Sold out">
                  <button style="display:none;" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">
                    <span id="AddToCartText-product-template">{{ $t('soldOut') }}</span>
                  </button>
                </div>
              </div>
                <!-- end b2c -->
                <!-- b2b -->
              <div v-if="this.business">
                <div v-if="!isOutOfStockBusiness()" class="product-form__item product-form__item--submit product-form__item--no-variants">
                  <input v-on:click="b2bAddToCart(product)" type="button" class="btn product-form__cart-submit fakeBUt" value="Add to Cart">
                  <button style="display:none;" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">
                    <span id="AddToCartText-product-template">{{ $t('addToCart') }}</span>
                  </button>
                </div>
                <!-- end b2b -->
                <div v-else class="product-form__item product-form__item--submit product-form__item--no-variants">
                <input type="button" class="btn product-form__cart-submit fakeBUt" value="Sold out">
                <button style="display:none;" name="add" id="AddToCart-product-template" class="btn product-form__cart-submit">
                  <span id="AddToCartText-product-template">{{ $t('soldOut') }}</span>
                </button>
              </div>
              </div>
              <!-- end sold out btn -->
              <!-- <span v-if="!this.business" class="time_tip">{{activeQuantity}} {{ $t('currentlyInCart') }}</span> -->
            </div>
            <div v-if="!business">
              <span v-if="product.LimitQuantityPerOrder>0" class="limit_tip">{{ $t('limit_left') }}{{product.LimitQuantityPerOrder}} {{ $t('limit_right') }}</span>
            </div>
            <div v-if="business">
              <span v-if="this.itemSelected && this.itemSelected.LimitQuantityPerOrder>0" class="limit_tip">{{ $t('limit_left') }}{{this.itemSelected.LimitQuantityPerOrder}} {{ $t('limit_right') }}</span>
            </div>
          </div>
          <!-- share -->
          <div class="share-container">
            <div>
              <h5>{{ $t('share') }}</h5>
              <social-sharing
                :url="this.$route.params.fullPath"
                inline-template
              >
                <div class="share-buttons-container">
                  <network network="pinterest">
                    <img src="../assets/img/icon_pin_black.png" alt="" />
                  </network>
                  <network network="facebook">
                    <img src="../assets/img/icon_fb_black.png" alt="" />
                  </network>
                  <network network="twitter">
                    <img src="../assets/img/icon_tw_black.png" alt="" />
                  </network>
                </div>
              </social-sharing>
            </div>
            <div v-if="product.IsProposition65" class="warning">
              <img src="../assets/img/warning.png" alt="">
              <span>
                For more information:
                <a class="warning-link" href="https://www.p65warnings.ca.gov/" target="_blank">www.P65Aarnings.ca.gov</a>
              </span>
            </div>
          </div>
          <!-- end share -->
         </div>
      </div>
      <!--end product detail-->
    </div>
    <div class="page-width">
      <!--description-->
      <div v-if="product.rich_text_description" class="product-single__description rte">
        <h2>{{ $t('description') }}</h2>
        <template></template>
        <p>
          <span class="rich-image" v-html="product.rich_text_description"></span>
        </p>
      </div>
      <!--end description-->

      <!-- recipe -->
      <div v-if="this.recipe.title" class="product-recipe">
        <h2>{{ $t('recipe') }}</h2>
        <div class="product-recipe-info">
          <div class="product-recipe-left">
            <h3>{{ $t('nutritionFacts') }}</h3>
            <hr>
            <p class="product-recipe-p">
              <span v-html="recipe.nutrition_facts"></span>
            </p>
            <h3>{{ $t('ingredient') }}</h3>
            <hr>
            <p class="product-recipe-p">
              <span v-html="recipe.rich_text_ingredient"></span>
            </p>
          </div>
          <div class="product-recipe-right">
            <h3>{{ $t('direction') }}</h3>
            <hr>
            <p class="product-recipe-p">
              <span v-html="recipe.rich_text_direction"></span>
            </p>
            <h3>{{ $t('preparation') }}</h3>
            <hr>
            <p class="product-recipe-p">
              <span v-html="recipe.rich_text_prep"></span>
            </p>
          </div>
        </div>
        <div v-if="this.recipe.videos.length > 0" class="product-recipe-videos">
          <h2>{{ $t('howDoYouMake') }}</h2>
          <ul class="recipe-videos">
            <li v-for="(item, index) in recipe.videos" :key='index'>
              <iframe :class="(recipe.videos.length===1) ? 'single-video' : ''" :src="item" frameborder="0" allowfullscreen></iframe>
            </li>
          </ul>
        </div>
      </div>
      <!-- end recipe -->

      <!--reviews (disable now)-->
      <!-- <div class="customer_reviews">
        <h2>Customer Reviews</h2>
        <div class="customer">
          <div class="customer_from">
            <div class="customer_list">
              <p >No reviews Yet</p>
              <span></span>
              <p @click="customerList">Write a review</p>
            </div>
            <el-form v-if="reviews" :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
              <h3 class="title">
                Write a review
              </h3>
              <el-form-item label="Name" prop="name">
                <el-input v-model="ruleForm.name" placeholder="Enter your name"></el-input>
              </el-form-item>
              <el-form-item label="Email" prop="email">
                <el-input v-model="ruleForm.Email" placeholder="Enter your Email"></el-input>
              </el-form-item>
              <el-form-item label="Rating">
                <el-rate
                  v-model="value2"
                  :colors="colors">
                </el-rate>
              </el-form-item>
              <el-form-item label="review Title" prop="title">
                <el-input v-model="ruleForm.title" placeholder="Give your review a title"></el-input>
              </el-form-item>
              <el-form-item label="Body of Review(1500) characters remaining " prop="remaining">
                <el-input type="textarea" :rows="8" v-model="ruleForm.body"
                          placeholder="Write your comments here"></el-input>
              </el-form-item>
              <div class="button">
                <el-button class="btn" @click="submitForm('ruleForm')">Submit Review</el-button>
              </div>
            </el-form>
          </div>
          <div class="customer_img">
            <img class="" src="../assets/img/Magic.png" alt="">
          </div>
        </div>
      </div> -->
      <!--end reviews-->

      <!-- swiper from the last category2-->
      <!-- b2c / b2b -->
      <div v-for="(item, index) in productData.slice(-1)" :key='index'>
        <div v-if="item.Products.length !== 0" class="cat">
          <div class="text-center">
            <h2 v-if='$i18n.locale=="en"'>{{item.Name}}</h2>
            <h2 v-if='$i18n.locale=="ch"'>{{item.Description}}</h2>
            <h2 v-if="!item.Name && !item.Description">More Products</h2>
          </div>
          <div class="swiperDiv">
            <swiper :options="productSwiper" ref="mySwiper">
              <swiper-slide v-for="(p, index) in item.Products" :key='index' :style="'width: 260px'">
                <productCard
                  v-if='$i18n.locale=="en"'
                  v-bind:img="p.Thumbnail"
                  v-bind:link="p.link"
                  v-bind:name="p.Name"
                  v-bind:isPromotion="p.IsPromotion"
                  v-bind:price="p.Price"
                  v-bind:item="p"
                  v-bind:quantity="p.Quantity"
                  v-bind:key="index"
                ></productCard>
                <productCard
                  v-if='$i18n.locale=="ch"'
                  v-bind:img="p.Thumbnail"
                  v-bind:link="p.link"
                  v-bind:name="p.Description"
                  v-bind:isPromotion="p.IsPromotion"
                  v-bind:price="p.Price"
                  v-bind:item="p"
                  v-bind:quantity="p.Quantity"
                  v-bind:key="index"
                ></productCard>
              </swiper-slide>
            </swiper>
            <div v-if="item.Products.length>5" class="swiper-button-prev swp2"></div>
            <div v-if="item.Products.length>5" class="swiper-button-next swp2"></div>
            <div class="moreDiv" @click="clickMore">All</div>
          </div>
        </div>
      </div>
      <!--end swiper-->
    </div>

    <div class="images-modal-mask" v-if="imagesVisible" @click.self="closeImages">
      <div class="images">
        <el-carousel :interval="5000" arrow="always">
          <el-carousel-item v-for="(item,index) in images" :key="'images'+index">
            <img :src="item" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { mapActions, mapMutations, mapState } from 'vuex';
import Router from 'vue-router';
import Vue from 'vue';
import VueHZoom from 'vue-h-zoom';
import smoothproducts from '../assets/js/smoothproducts.min';
import breadcrumb from '../components/breadcrumb';
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart,
} from "../store/modules/cart";
import productCard from "./productCard";
import {DISPLAY_PRODUCTS_GROUP} from '@/api/url.js';
Vue.use(VueHZoom);
// Vue.component('originalVueZoom', VueHZoom);
var SocialSharing = require('vue-social-sharing');
Vue.use(SocialSharing);
// const newZoom = Vue.component('originalVueZoom').extend({
//   methods: {
//     updateThumbnailPos: function () {
//       const el = this.$refs.thumbnail;
//       let elementDim = el.getBoundingClientRect();
//       this.thumbnailPos = {
//         top: elementDim.top,
//         left: elementDim.left,
//       }
//     }
//   }
// });
export default {
  name: "productDetails",
  components: {
    breadcrumb,
    VueHZoom: VueHZoom,
    productCard,
  },
  metaInfo() {
    const product = this.product;
    if (product) {
      return {
        title: `${product.meta_title}`,
        meta: [
          { name: 'description', content: `${product.meta_description}` },
          { name: 'keywords', content: `${product.meta_keywords}` },
          { name: 'robots', content: "index,follow" }
        ]
      }
    }
  },
  data() {
    return {
      value: '',
      zoom: {
        screenWidth: 0,
        width: 0,
        height: 0,
        zoomX: 0,
        zoomY: 0,
      },
      num: 0, // number count
      itemSelected: '',
      review: 0,
      productChoice: '',
      cartCount: 0,
      productDetail: {},
      productSwiper: {
        slidesPerView: 5,
        navigation: {
          nextEl: '.swiper-button-next.swp2',
          prevEl: '.swiper-button-prev.swp2',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          //when width >= 480
          480:{
            slidesPerView: 2,
          },
          767: {
            slidesPerView: 2,
          },
          //when width >= 640
          990: {
            slidesPerView: 3,
          },
          1200:{
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          }
        }
      },
      bigImg: "",
      zoomImg: "",
      isactive: 0, //click
      //review info
      reviews:false,//show rview submit
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      rules: {
        name: [
          {required: true, errorMessage: 'name can not be empty', trigger: 'blur'}
        ],
        email: [
          {required: true, errorMessage: 'email can not be empty', trigger: 'blur'}
        ],
        title: [
          {required: true, errorMessage: 'title can not be empty', trigger: 'blur'}
        ],
        body: [
          {required: false, errorMessage: '', trigger: 'blur'}
        ]
      },
      value2: null, // piclk star level
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'], //star color = { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
      recipe: {},
      b2bName: '',
      b2bDescription: '',
      //商品图片的弹窗
      imagesVisible: false,
      images: [],
      productData: []
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  mounted() {
    const url = this.$route.params.product;
    const productId = this.activeProduct || url.split('-')[0];
    this.getProductRecipe(productId);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapActions('products', ['fetchProductDetails', 'fetchProductRecipe']),
    ...mapActions('cart', ['addProductToCart', 'addCart']),
    ...mapMutations('products', ['updateActiveProduct', 'updateActiveQuantity']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    tabImg(num) {
      this.bigImg = this.product.Images[num]; // right side big img
      this.zoomImg = this.product.Large_Images[num]; // zoom big img
      this.isactive = num; // tab the img
    },
    initializeValue() {
      this.bigImg = "";
      this.zoomImg = "";
      this.isactive = 0;
      this.num = 1;
    },
    // this is not doing anything
    handleResize() {
      this.zoom.screenWidth = window.innerWidth;
      if (this.zoom.screenWidth>1139) {
        this.zoom.width = 400;
        this.zoom.height = 400;
        this.zoom.zoomX = 400;
        this.zoom.zoomY = 100;
      } else if (this.zoom.screenWidth<1140 && this.zoom.screenWidth>892) {
        this.zoom.width = 300;
        this.zoom.height = 300;
        this.zoom.zoomX = 400;
        this.zoom.zoomY = 100;
      } else if (this.zoom.screenWidth<893 && this.zoom.screenWidth>772) {
        this.zoom.width = 278;
        this.zoom.height = 278;
        this.zoom.zoomX = 300;
        this.zoom.zoomY = 100;
      }
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
      .then( () => {
        this.$store.dispatch('cart/getCart')
      })
    },
    handleAddToCartFail(product) {
      if (product.ConvertNum === 1) {
        alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
      }
    },
    addToCart: function(item) {
      item.quantity = this.num;
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
      }
      this.num=1;
    },
    findB2BItem(load, newVal, oldVal) {
      if (this.business) {
        if (load) {
          // load here means on page load or component mount.
          this.alternativeProducts.map(item => {
            if (newVal === item.Product_id) {
              this.itemSelected = item;
            }
          })
        } else {
          // if productChoice doesn't have a value it means the b2b dropdown is empty. this selects a default on function fire.
          if (this.productChoice === '') {
            if (this.productsArray.length === 1) {
              this.productChoice = this.productsArray[0].value;
              this.b2bName = this.productsArray[0].Name
              this.b2bDescription = this.productsArray[0].Description
            }
             else if (this.productDetails) {
              let master = this.productsArray.filter(item => item.ProductNum.charAt(item.ProductNum.length -1) === "0");
              let inner = this.productsArray.filter(item => item.ProductNum.charAt(item.ProductNum.length -1) === "2");
            if (master) {
              this.productChoice = master[0].value;
              this.b2bName = master[0].Name
              this.b2bDescription = master[0].Description
            } else if (inner) {
              this.productChoice = inner[0].value;
              this.b2bName = inner[0].Name
              this.b2bDescription = inner[0].Description
            }
          }
          }
        }
      }
    },
    b2bAddToCart(item) {
      item.quantity = this.num;
      if (isUserAuthenticated()) {
       this.addCart(item)
        .then(() => {
          this.$store.dispatch('cart/getCart')
        });
      }
      this.num=1;
    },
    isOutOfStockBusiness(b2bItem) {
      const { Sales_Order_Lines } = this.cartProductsList;
      let stockInCart = 0;
      if (this.product.IsOverSaleable) {
        return false;
      }else{
        if(this.product.StockLevel>stockInCart){
          return false;
        }else{
          return true;
        }
      }
      // Sales_Order_Lines.map(item => {
      //   if (this.itemSelected && (item.Product_id === this.itemSelected.Product_id)) {
      //     stockInCart += item.ConvertNum * item.Quantity
      //   }
      // })
      // if (this.itemSelected && (stockInCart + this.itemSelected.ConvertNum >= this.product.StockLevel)) {
      //   return true;
      // }
      // if (this.itemSelected) {
      //   return this.itemSelected.ConvertNum <= this.product.StockLevel ? false : true;
      // }
    },
    // review list change
    customerList() {
      this.reviews = !this.reviews;
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    getProductRecipe(id) {
      this.fetchProductRecipe(id)
      .then(res => {
        if (res.data.length === 1) {
          this.recipe = res.data[0];
          if (this.recipe.videos) {
            this.recipe.videos = JSON.parse(this.recipe.videos);
          }
        }
      })
      .catch(err => {
        console.log('err', err)
      })
    },
    //点击商品图片
    clickZoom(images){
      if(images.length !== 0){
        console.log('clickZoom',images);
        //显示商品图片的弹窗
        this.imagesVisible=true;
        this.images=images;
      }
    },
    closeImages(){
      this.imagesVisible=false;
    },
    //点击显示更多此类的产品
    clickMore(){
      const group = this.allGroups.filter( group => group.ProductGroup_id === this.product.ProductGroup_id)[0];
      if(this.$router.currentRoute.params && this.$router.currentRoute.params.group) {
        if((this.$router.currentRoute.params.group.toLowerCase() !== group.Name.toLowerCase()) || this.$router.currentRoute.params.group.toLowerCase() === 'eats') {
          this.$router.push(`/collections/${group.Name.toLowerCase()}`)
        } else {
          this.$root.fetchSelectedGroup(group.ProductGroup_id);
        }
      } else {
        this.$router.push(`/collections/${group.Name.toLowerCase()}`)
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (isUserAuthenticated() && to.name === 'purchase') {
      this.$store.dispatch('cart/getCart')
      .then(() => {
        const cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
        this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
        .then(() => {
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        })
      })
    }
    this.clearPromoCode();
    this.clearCard();
    next();
  },
  computed: mapState({
    activeProduct: state => state.products.activeProduct,
    product: state => state.products.productDetails[0],
    alternativeProducts: state => state.products.productDetails,
    necessaryCartItems: state => state.cart.necessaryCartItems,
    cart: state => state.cart.cart,
    cartProductsList: state => state.cart.cartProductsList,
    productDetails: state => state.products.productDetails,
    itemCount: state => state.cart.itemCount,
    itemDeleted: state => state.cart.itemDeleted,
    productsArray: state => state.products.productsArray,
    business: state => state.auth.userDetails.IsBusiness,
    customerInfoSuccess: state => state.auth.customerInfoSuccess,
    activeQuantity: state => state.products.activeQuantity,
    allGroups: state => state.navbar.allGroups,
    innerMaster() {
      if (this.productDetails[1]) {
        if (this.productDetails[1].ProductNum.charAt(this.productDetails[1].ProductNum.length - 1) === "2") {
          return "Inner";
        }
        if (this.productDetails[1].ProductNum.charAt(this.productDetails[1].ProductNum.length - 1) === "0") {
          return "Master";
        }
      }
    },
    loggedIn: state => state.auth.loggedIn,
  }),
  watch: {
    '$route': {
      immediate: true,
      handler(newVal) {
        const url = this.$route.params.product;
        const productNum = this.activeProduct || url.split('-')[0];
        this.fetchProductRecipe(productNum);
        this.fetchProductDetails(productNum)
        .then(() => {
          this.updateActiveProduct(productNum);
          this.productChoice = '';
          // this.itemSelected = {};
          this.findB2BItem(false);
          this.initializeValue();
        });
        // this.$store.dispatch('products/fetchCustomCategories', this.business);
        this.$store.dispatch('products/fetchB2BCustomCategories', this.business);
      }
    },
    itemDeleted: function(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.cartCount = 0;
      }
    },
    productChoice: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.findB2BItem(true, newVal, oldVal);
      }
    },
    // offline
    cartProductsList: {
      deep: true,
      handler(newVal) {
        let quantFound = false;
        //Unfortunately, because `item.quantity` is used in other places, we can't combine the authenticated and unauthenticated mapping into one function and use || to delineate between the two. --Anthony
          if (isUserAuthenticated()) {
            this.cartProductsList.Sales_Order_Lines.map(item => {
              if (item.ProductNum === this.activeProduct) {
                quantFound = true;
                this.updateActiveQuantity(item.Quantity)
              }
            })
          } else {
              this.cartProductsList.map(item => {
              if (item.ProductNum === this.activeProduct) {
                quantFound = true;
                this.updateActiveQuantity(item.quantity)
              }
            })
          }
          if (!quantFound) {
            this.updateActiveQuantity(0);
          }
      }
    },
    business: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.findB2BItem(false)
      }
    },
    product: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        //根据组别显示同组别的产品
        let data = {
          id: this.product.ProductGroup_id,
          isB2B: this.business,
          limit: 10
        }
        let config = {
          url: `${DISPLAY_PRODUCTS_GROUP}/${data.id}`,
          method: 'GET',
          params: {
            limit: data.limit
          }
        };
        //保存到data
        axios(config).then((response) => {
          console.log('response',response)
          let res=['0','12',{
            Products:response.data
          }]
          this.productData=res;
        }, (err) => {
          console.log('response',response)
        })
      }
    },
  },
  customerInfoSuccess: function(newVal, oldVal ) {
    this.fetchProductDetails(this.product.productNum)
    .then(() => {
      this.productChoice = '';
      this.itemSelected = {};
      this.findB2BItem(false);
      this.initializeValue();
    })
  },
}
$(function () {
  $('.sp-wrap').smoothproducts();
})
</script>

<style lang="less">
@import "../assets/css/public.less";
@import "../assets/css/details.less";
@import "../assets/css/jqzoom.css";
@import "../assets/css/navbar.less";
@import "../assets/css/smoothproducts.css";
</style>



// WEBPACK FOOTER //
// src/view/productDetails.vue